import React from 'react';
import classes from './button.module.css';

const Button = (props) => {
    const isTournamentCreateButton = props.content === "CREATE A TOURNAMENT";
    
    return (
        <button className={`${classes.Button} ${props.whiteBackground && classes.WhiteBackground} 
        ${props.icon && classes.WithIcon} ${props.disabled && classes.Disabled}
        ${isTournamentCreateButton && classes.TournamentCreateButton}`} 
        onClick={props.onClick} type={props.type} disabled={props.disabled}>
            {props.content}
            {props.icon && <img src={props.icon} alt={props.content} />}
        </button>
    )
}
export default Button;